import { Link } from 'react-router-dom';

const footerLinks = [
  { name: 'من نحن', path: '/page/about' },
  { name: 'سياسة الخصوصية', path: '/page/privacy' },
  { name: 'إخلاء المسؤولية', path: '/page/disclaimer' }
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-border mt-auto">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-right">
            <p className="text-muted-foreground text-sm">
              © 2026 عروض - Oroodh.com. جميع الحقوق محفوظة.
            </p>
          </div>

          <nav className="flex items-center gap-6">
            {footerLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
                data-testid={`footer-${link.name}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}